import {
  UserNotificationPreferenceUpdateRequestType,
  UserNotificationPreferenceUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useUserNotificationPreferenceUpdate = (
  userNotificationPreferenceId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: UserNotificationPreferenceUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `user-notification-preference/${userNotificationPreferenceId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as UserNotificationPreferenceUpdateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.UserNotificationPreferences,
          userNotificationPreferenceId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.SellarUser],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.NotificationToken],
      });
    },
  });
};
